export default __webpack_public_path__ + "141345c7e3b29f4d6cd34ddea1c21e9c.svg";